var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vmp-img-stream"},[_c('img',{ref:"capImage",staticStyle:{"margin-right":"20px","vertical-align":"top"},attrs:{"alt":_vm.$t('host.k_530001'),"crossorigin":"anonymous"}}),_c('canvas',{ref:"capCanvas",attrs:{"id":"capCanvas"}},[_vm._v(" Your browser does not support the HTML5 canvas tag. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }